import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { Bell, PlayCircle, History, Landmark, BarChart3, FileText, Clock, UserCog, Building2, Upload, FileSpreadsheet } from "lucide-react";

const ITEMS = [
  { area: "people", path: "/people", label: "People", icon: UserCog },
  { area: "time", path: "/time", label: "Time", icon: Clock },
  { area: "run_payroll", path: "/run-payroll", label: "Run Payroll", icon: PlayCircle },
  { area: "history", path: "/history", label: "Payroll History", icon: History },
  { area: "remittance", path: "/remittance", label: "Remittance (PD7A)", icon: Landmark },
  { area: "reports", path: "/reports", label: "Reports", icon: BarChart3 },
  { area: "t4", path: "/t4", label: "T4 Slip", icon: FileText },
  { area: "roe", path: "/roe", label: "ROE", icon: FileSpreadsheet },
  { area: "migration", path: "/migration", label: "Migration", icon: Upload },
];

// Sticky company-workspace header shown across all staff company-scoped pages.
export default function CompanyWorkspaceNav() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const cid = params.get("company") ||
    (location.pathname.startsWith("/companies/") ? location.pathname.split("/")[2] : "");
  const [name, setName] = useState("");
  const [timeTab, setTimeTab] = useState(true);
  const [migClosed, setMigClosed] = useState(false);

  useEffect(() => {
    if (!cid) { setName(""); return; }
    const fetchCo = () => api.get(`/companies/${cid}`).then((r) => { setName(r.data?.name || ""); setTimeTab(r.data?.time_tab_enabled !== false); setMigClosed(!!r.data?.migration_closed); }).catch(() => setName(""));
    fetchCo();
    window.addEventListener("company-settings-changed", fetchCo);
    return () => window.removeEventListener("company-settings-changed", fetchCo);
  }, [cid]);

  if (!cid) return null;
  const onHub = location.pathname === `/companies/${cid}`;

  return (
    <div className="sticky top-0 z-20 -mx-4 md:-mx-8 -mt-4 md:-mt-8 mb-6 bg-white/90 backdrop-blur border-b border-border" data-testid="company-workspace-nav">
      <div className="px-4 md:px-8 pt-3">
        <Link to={`/companies/${cid}`} data-testid="workspace-company-name" className="inline-flex items-center gap-2 text-sm font-black tracking-tight hover:opacity-70 transition-opacity">
          <Building2 className="h-4 w-4" /> {name || "Company"}
        </Link>
      </div>
      <div className="flex flex-wrap gap-1 px-4 md:px-8 pt-2 pb-2">
        <Link to={`/companies/${cid}`} data-testid="workspace-nav-overview"
          className={`flex items-center gap-1.5 px-3 py-2 text-xs font-medium border-b-2 -mb-px transition-colors ${onHub ? "border-black text-black" : "border-transparent text-muted-foreground hover:text-black"}`}>
          Overview
        </Link>
        {ITEMS.filter((t) => (t.area !== "time" || timeTab) && (t.area !== "migration" || !migClosed)).map((t) => {
          const active = location.pathname.startsWith(t.path);
          return (
            <Link key={t.area} to={`${t.path}?company=${cid}`} data-testid={`workspace-nav-${t.area}`}
              className={`flex items-center gap-1.5 px-3 py-2 text-xs font-medium border-b-2 -mb-px transition-colors ${active ? "border-black text-black" : "border-transparent text-muted-foreground hover:text-black"}`}>
              <t.icon className="h-3.5 w-3.5" /> {t.label}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
